var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c(_vm.componentName,{tag:"component",attrs:{"show":_vm.show},on:{"changeView":_vm.oncChangeView}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }